import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen 
      bg-gradient-to-b from-gray-800 to to-black text-white
      pl-3"
    >
      <div
        className="max-w-screen-lg p-4 mx-auto flex flex-col 
      justify-center w-full h-full"
      >
        <div className="pb-5">
          <h1
            className="text-4xl font-bold inline
           border-b-4 border-gray-500"
          >
            About
          </h1>
        </div>

        <p className="text-xl mt-20">
          I really love solving problems and building new things. So my interest
          developed in coding when i was in my 11th standard, i learned C, C++
          and practices coding problems on them fast forward to B.Tech journey i
          always wonder how big scale application builds up. So i explored
          different technologies and started learning{" "}
          <span className="text-2xl">React, Node, Javascript and MongoDb</span>{" "}
          which i found very intresting.
        </p>
        <p className="pt-4 text-xl">
          That's how i become MERN stack developer. ❤️
        </p>
        <br />
        <p className="text-xl">
          If you want to know more about me on which Projects and Technologies i
          have worked with checkout my Portfolio and Experience section and in
          case you like my work then Contact me.
        </p>

        <p className="text-xl py-5">
          In case you find any potential in my work then you can download my
          resume from left section and{" "}
          <span className="underline"> invite me for an interview.</span>
        </p>
      </div>
    </div>
  );
};

export default About;
